import { CardNumberElement } from "@stripe/react-stripe-js"
import { BOOKING_SOURCE } from "pagesV2/pro/Bookings/constants"
import { attachUserPaymentMethod, failedPaymentMethods } from "store/user"

// The card typed into the card fields, saved to the guest before it is charged, as the old widget
// does: a balance paid later is charged to this saved card. `guestToken` is the order's (a single
// booking's token is already stored). Resolves with { paymentMethodId } or { error } (Stripe's
// message for a card error, else null for the caller's own wording).
export const createGuestCard = async ({ stripe, elements, dispatch, values, clientId, guideId, guestToken }) => {
  const { paymentMethod, error } = await stripe.createPaymentMethod({
    type: "card",
    card: elements.getElement(CardNumberElement),
    billing_details: { name: values?.cardName, address: { postal_code: values?.zip } }
  })
  dispatch(failedPaymentMethods())
  if (error) return { error: error.type === "card_error" ? error.message : null }
  const card = { new_user: false, id: clientId, payment_method_id: paymentMethod.id, booking_source: BOOKING_SOURCE.embedded, guide_id: guideId }
  await dispatch(attachUserPaymentMethod(card, { guestToken }))
  return { paymentMethodId: paymentMethod.id }
}
